// extracted by mini-css-extract-plugin
module.exports = {"THEME_NAME":"\"fixtercore\"","body":"layout_body__J7CSL"};